'use client'

import Link from 'next/link'
import { ArrowUpRight } from 'lucide-react'
import { trackCtaClicked } from '../../lib/analytics'

export const ARTICLE_CTA_DEFAULTS = {
  heading: 'Have questions about your immigration options?',
  description:
    'Our attorneys are here to help you navigate the complexities of U.S. immigration law.',
  buttonText: 'Book a Consultation',
  buttonLink: '/consultation',
} as const

interface ArticleConsultationCtaBarProps {
  heading?: string | null
  description?: string | null
  buttonText?: string | null
  buttonLink?: string | null
  location: 'article_inline' | 'article_end'
  className?: string
}

export function ArticleConsultationCtaBar({
  heading,
  description,
  buttonText,
  buttonLink,
  location,
  className = '',
}: ArticleConsultationCtaBarProps) {
  const resolvedHeading = heading?.trim() || ARTICLE_CTA_DEFAULTS.heading
  const resolvedDescription = description?.trim() || ARTICLE_CTA_DEFAULTS.description
  const resolvedButtonText = buttonText?.trim() || ARTICLE_CTA_DEFAULTS.buttonText
  const resolvedButtonLink = buttonLink?.trim() || ARTICLE_CTA_DEFAULTS.buttonLink

  return (
    <div
      className={`bg-gray-50 border border-gray-200 rounded-xl p-6 md:p-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 ${className}`}
    >
      <div>
        <p className="text-gray-900 font-medium mb-1">{resolvedHeading}</p>
        <p className="text-gray-600 text-sm">{resolvedDescription}</p>
      </div>
      <Link
        href={resolvedButtonLink}
        onClick={() =>
          trackCtaClicked({
            cta_text: resolvedButtonText,
            cta_location: location,
            destination_url: resolvedButtonLink,
          })
        }
        className="inline-flex items-center gap-2 px-6 py-3 bg-brand-blue text-white rounded-full hover:bg-brand-blue/90 transition-colors text-sm font-medium whitespace-nowrap"
      >
        {resolvedButtonText}
        <ArrowUpRight className="w-4 h-4" />
      </Link>
    </div>
  )
}
